import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import PropTypes from 'prop-types';

import { DatePickerField } from 'src/components/DatePickerField/DatePickerField';
import Button from 'src/components/Button';
import s from './ColumnFilters.styles';

const ColumnPopupFilterDate = ({ value, onChange, onClose }) => {
  const [from, setFrom] = useState(value ? value.from : null);
  const [to, setTo] = useState(value ? value.to : null);

  const { t } = useTranslation();

  const changeFromDateAsUTC = (date) => {
    const tmpMoment = moment(date).toDate();

    return `${tmpMoment.getFullYear()}-${tmpMoment.getMonth()+1}-${tmpMoment.getDate()} 00:00:00`;
  };
  const changeToDateAsUTC = (date) => {
    const tmpMoment = moment(date).toDate();

    return `${tmpMoment.getFullYear()}-${tmpMoment.getMonth()+1}-${tmpMoment.getDate()} 23:59:59`;
  };

  const onSubmit = () => {
    onChange({
      from: from ? changeFromDateAsUTC(moment(from).toDate()) : null,
      to: to ? changeToDateAsUTC(moment(to).toDate()) : null,
    });
    onClose();
  };

  return (
    <s.MorePopup date>
      <DatePickerField
        dateOnly={true}
        label={t('START')}
        maxDate={to ? moment(to).toDate() : null}
        onChange={e => setFrom(e)}
        placeholderText="mm-dd-yyyy"
        value={from}
      />
      <DatePickerField
        dateOnly={true}
        label={t('END')}
        minDate={from ? moment(from).toDate() : null}
        onChange={e => setTo(e)}
        placeholderText="mm-dd-yyyy"
        value={to}
      />
      <s.ButtonsRow>
        <Button onClick={() => onSubmit()} orange sm solid>
          {t('APPLY')}
        </Button>
        <Button ghost onClick={() => onClose()} red sm type="button">
          {t('CANCEL')}
        </Button>
      </s.ButtonsRow>
    </s.MorePopup>
  );
};

ColumnPopupFilterDate.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
};

export default React.memo(ColumnPopupFilterDate);
